import {formatters, strings} from "@atttomyx/shared-utils";

export const formatPrice = (price) => {
    let formatted = "quote";

    if (price) {
        formatted = formatters.usDollars(price);
        formatted = strings.removeTrailing(formatted, ".00");
    }

    return formatted;
};
